import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import logo from '../../assets/images/landing/logo.svg';
import { useAuthContext, useAuthInitializedContext } from '../../hooks/use-user-auth-context.hooks';
import { dispatchLogout } from '../../redux/slice/auth/auth.operations';
import { User } from '../../redux/slice/auth/auth.types';
import { useAppDispatch } from '../../redux/store';
import logger from '../../services/logger';
import Container from '../container/Container';

export const Header: React.FC = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const userInitialized = useAuthInitializedContext();
  const user: User | null = useAuthContext();
  const isAuthenticated: boolean = user ? true : false;
  const isLandingPage = location.pathname === '/';

  const handleLogout = async () => {
    try {
      await dispatch(dispatchLogout());
      toast.success('Logged out!');
      navigate('/login');
    } catch (e) {
      logger.error('Failed to logout.', e);
      toast.error('Logout failed.');
    }
  };
  return (
    <header className={`py-3 relative w-full z-10 ${!isLandingPage ? 'shadow bg-white' : ''}`}>
      <Container>
        <nav className="navbar flex">
          <div className="navbar-brand mr-4">
            <Link to="/">
              <div>
                <img src={logo} alt="" />
              </div>
            </Link>
          </div>
          <ul
            className={`navbar-nav flex items-center gap-8 ml-auto ${
              isLandingPage ? 'text-white' : 'text-black'
            } `}
          >
            {userInitialized ? (
              !isAuthenticated ? (
                <>
                  <li>
                    <Link to="/">About Us</Link>
                  </li>
                  <li>
                    <Link to="/">Contact Us</Link>
                  </li>
                  <li className="">
                    <Link
                      to="/signup"
                      className={`${
                        isLandingPage ? 'bg-white text-purple-600' : 'bg-purple-700 text-white'
                      } p-3 px-8 rounded-xl font-medium`}
                    >
                      Get Started
                    </Link>
                  </li>
                </>
              ) : (
                <li>
                  <button
                    // eslint-disable-next-line @typescript-eslint/no-misused-promises
                    onClick={handleLogout}
                    className={`${
                      isLandingPage ? 'bg-white text-purple-600' : 'bg-purple-700 text-white'
                    } p-3 px-8 rounded-xl font-medium`}
                  >
                    Log Out
                  </button>
                </li>
              )
            ) : null}
          </ul>
        </nav>
      </Container>
    </header>
  );
};
